import * as React from 'react';
import { filterByDocumentType } from 'Utility/documentHandling';
import ComorbidityForm from './ComorbidityForm';
import ContraceptionForm from './ContraceptionForm';
import HospitalizationForm from './HospitalizationForm';
import PregnancyForm from './PregnancyForm';
import SickleaveForm from './SickleaveForm';

import type { TComorbidityDocumentType } from 'Routes/Comorbidity/utils';

const Form = ({
  documents,
  document,
  formData,
  editing,
  medicationNames,
  diagnosis,
  platform,
}: IOwnProps): React.JSX.Element | null => {
  switch (document?._type) {
    case 'comorbidity':
      return (
        <ComorbidityForm
          documents={filterByDocumentType(documents, 'comorbidity')}
          formData={formData}
          editing={editing}
          medicationNames={medicationNames}
          diagnosis={diagnosis}
        />
      );
    case 'hospitalization':
      return (
        <HospitalizationForm
          documents={filterByDocumentType(documents, 'hospitalization')}
          formData={formData}
          editing={editing}
          medicationNames={medicationNames}
          platform={platform}
        />
      );
    case 'pregnancy':
      return (
        <PregnancyForm documents={filterByDocumentType(documents, 'pregnancy')} formData={formData} editing={editing} />
      );
    case 'contraception':
      return <ContraceptionForm formData={formData} editing={editing} />;
    case 'sickLeave':
      return <SickleaveForm formData={formData} editing={editing} diagnosis={diagnosis} />;
    default:
      return null;
  }
};
interface IOwnProps {
  documents: IDocumentWithTypeV2<TComorbidityDocumentType>[];
  document?: IDocumentWithTypeV2<TComorbidityDocumentType>;
  formData: IFormData<
    IDocumentWithTypeV2<'comorbidity' | 'hospitalization' | 'pregnancy' | 'contraception' | 'sickLeave'>
  >;
  editing: boolean;
  medicationNames: string[];
  diagnosis: string[];
  platform?: Platform;
}

export default Form;
